import React from "react";
import Loader from "components/Loader";

const Progress_bar = ({
  bgcolor,
  progress,
  text,
  id,
  setChecked,
  optionLoading,
  optionId,
  loading,
}) => {
  return (
    <div
      className="ProgressPollParentdiv"
      onClick={optionLoading || loading ? () => {} : () => setChecked(id)}
    >
      <div
        className="progressPollChilddiv"
        style={{ width: `${progress}%`, backgroundColor: bgcolor }}
      >
        <span className="barName">{text}</span>
        <span className="pollIfat">{`${progress}%`}</span>
        {optionLoading && optionId === id ? (
          <span>
            <Loader width={40} height={25} />
          </span>
        ) : null}
      </div>
    </div>
  );
};

export default Progress_bar;
